import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';
import UserLookup from '../Models/Identity/UserLookup';

export interface IUserApiClient {

    /** 
     * Gets a list of user lookups
     */
    getUserLookups(): AxiosPromise<Array<Model.PlainObject<UserLookup>>>;

    // Client only properties / methods
}

@injectable()
export default class UserApiClient extends Data.ApiClientBase implements IUserApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/users`);
    }

    public getUserLookups(): AxiosPromise<Array<Model.PlainObject<UserLookup>>> {
        return this.axios.get(`${this.apiPath}/lookups`);
    }

    // Client only properties / methods
}